module.exports = __webpack_public_path__ + "img/crock-pot-honey-garlic-chicken.1bd31c7a.jpg";